import { render, staticRenderFns } from "./ActivationBriefPaymentsProvider.vue?vue&type=template&id=538f6747&scoped=true&"
import script from "./ActivationBriefPaymentsProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefPaymentsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f6747",
  null
  
)

export default component.exports